// action
import OdataCoreActionBase from "@/core/actions/OdataCoreActionBase";
// service
import ClientContentMetricsService from "@/core/services/metrics/ClientContentMetricsService";


class ClientContentMetricsAction extends OdataCoreActionBase {

    constructor( dispatch: any, screenCode:string ) {

        super(dispatch, ClientContentMetricsService, screenCode);
    
    }

}

export default ClientContentMetricsAction;
